import { render, staticRenderFns } from "./ArticleFooter.vue?vue&type=template&id=2620a44f"
import script from "./ArticleFooter.vue?vue&type=script&lang=js"
export * from "./ArticleFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports